export default "__VITE_ASSET__acc01665__"